import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {Button, Paper} from "@mui/material";
import {useNavigate} from "react-router";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Assignment} from "@mui/icons-material";


export const FornecedoresIndexPage = () => {
	const navigate = useNavigate();
	
	return (<DefaultContainer titulo={'Fornecedores'}
	                          size={'medium'}
	                          component={Paper}>
			<Button endIcon={<Assignment/>}
			        variant="outlined"
			        color="primary"
			        onClick={() => navigate(_Sitemap.fornecedores.children.lista.fullUrl)}
			        fullWidth>
				Gerenciar fornecedores
			</Button>
		</DefaultContainer>
	);
};